import React from "react";

const MoveRightIcon = ({ className, disabled }) => (
  <>
    <svg
      className={className}
      width='23'
      height='24'
      viewBox='0 0 23 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.0304 11.5504L8.98036 5.26292C8.95932 5.24636 8.93404 5.23607 8.90742 5.23323C8.8808 5.23038 8.85392 5.23511 8.82987 5.24686C8.80581 5.25861 8.78556 5.2769 8.77143 5.29964C8.7573 5.32238 8.74987 5.34865 8.75 5.37542V6.75578C8.75 6.84328 8.79107 6.9272 8.85893 6.98078L15.2875 12.0004L8.85893 17.0201C8.78929 17.0736 8.75 17.1576 8.75 17.2451V18.6254C8.75 18.7451 8.8875 18.8111 8.98036 18.7379L17.0304 12.4504C17.0988 12.397 17.1541 12.3288 17.1922 12.2508C17.2303 12.1728 17.2501 12.0872 17.2501 12.0004C17.2501 11.9136 17.2303 11.828 17.1922 11.75C17.1541 11.6721 17.0988 11.6038 17.0304 11.5504Z'
        fill={disabled ? "var(--du-color-grey)" : "var(--du-color-black)"}
      />
    </svg>
  </>
);
export default MoveRightIcon;
